import React from 'react';

import classes from './TitleBlock.module.scss';
import ErrorIcon from '../../../../../../../assets/images/vectors/error-rounded.svg';
import { getPriceView } from '../../../../../shared/utils/stringUtils';

type TitleBlockProps = {
  orderAmount: number;
};

const TitleBlock = ({ orderAmount }: TitleBlockProps) => {
  return (
    <div className={classes.block}>
      <img src={ErrorIcon} alt="error" className={classes.errorIcon} />
      <h3 className={classes.title}>
        Access Denied - Payment Failed ({getPriceView(orderAmount / 100)} Due)
      </h3>
      <p className={classes.description}>
        There was a problem processing your payment. Please choose an option to update
        your payment method or retry the transaction.
      </p>
    </div>
  );
};

export { TitleBlock };
